// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iki2aUT1AUXwK0 {
  margin-left: 40px;
}
.b6hNLqLGB3t45H {
  margin: 0;
  padding: 0;
  list-style: none;
}
.b6hNLqLGB3t45H li {
  position: relative;
  padding: 2px 0;
  border-bottom: 1px solid var(--ds-border, #091e4224);
}
.b6hNLqLGB3t45H li a {
  display: block;
  position: relative;
  padding: 6px 80px 6px 8px;
  border-radius: 3px;
  color: var(--ds-text, #172b4d);
  text-decoration: none;
}
.b6hNLqLGB3t45H li a:hover {
  border-radius: 3px;
  background-color: var(--ds-background-neutral, #091e4224);
}
.b6hNLqLGB3t45H li .Vto67uQhYgBtbd {
  margin-bottom: 0;
  padding: 0 4px 0 0;
}
.hqVFRLbPCYzjkR {
  padding: 2px;
  font-size: 16px;
  line-height: 20px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ulGutter": `iki2aUT1AUXwK0`,
	"orgList": `b6hNLqLGB3t45H`,
	"itemName": `Vto67uQhYgBtbd`,
	"itemIcon": `hqVFRLbPCYzjkR`
};
export default ___CSS_LOADER_EXPORT___;
